var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.908875 11.7198L2.89776 10.158M25.4204 11.7198L13.3797 1.92688L6.0692 7.66754M2.89776 10.158V3.82006H6.0692V7.66754M2.89776 10.158L6.0692 7.66754M9.50942 26.622V18.1064H16.8199V26.622H23.7003V13.4229L13.3797 5.3331L2.62898 13.4229V26.622H9.50942Z",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_410",
    x1: 0.908875,
    y1: 1.92688,
    x2: 25.6822,
    y2: 2.19231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#142FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B406B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f7ab57718669773efa71368cdec3288f.svg";
export { ForwardRef as ReactComponent };